import { useParams, useSearchParams } from 'react-router-dom';
import { convertSearch } from 'utils/helpers/searchString';
import {
  GetUsersOrderByEnum,
  NaimixRegistrationCheckStatusEnum,
  NaimixRegistrationPersonalInfoStatusEnum,
  OrderDirectionEnum,
  UserContractNaimixStatusEnum,
  UserRoleEnum,
} from 'generated/graphql';
import { useMemo } from 'react';
import { useGetUsersQuery } from 'pages/users/api/queries/generated/GetUsers';

export const useGetUsers = () => {
  const [params] = useSearchParams();
  const router = useParams();
  const objectId = router.facilityId || params.get('facilityId');
  const documentStatusParam = params.get('documentStatus');
  const personalStatusParam = params.get('personal-status');
  const taxParam = params.get('tax');
  const paymentInfoParam = params.get('payment-info');
  const citizenshipParam = params.get('citizenship');
  const roleParam = params.get('role');
  const searchQuery = params.get('search');
  const orderBy = params.get('sortBy');
  const orderDirection = params.get('sortWay');
  const pageParam = params.get('page');
  const page = pageParam ? +pageParam : 1;
  const limitParam = params.get('limit');
  const limit = limitParam ? +limitParam : 25;
  const offset = (page - 1) * limit;

  const {
    data: dataUsers,
    loading: loadingUsers,
    error,
  } = useGetUsersQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        limit,
        offset,
        ...(searchQuery && { searchQuery: convertSearch(searchQuery) }),
        ...(orderBy && { orderBy: orderBy as GetUsersOrderByEnum }),
        ...(orderDirection && { orderDirection: orderDirection as OrderDirectionEnum }),
        ...(objectId && { objectId }),
        ...(documentStatusParam && { naimixContractStatus: documentStatusParam as UserContractNaimixStatusEnum }),
        ...(personalStatusParam && {
          naimixPersonalInfo: personalStatusParam as NaimixRegistrationPersonalInfoStatusEnum,
        }),
        ...(taxParam && { naimixTaxPartnerInfo: taxParam as NaimixRegistrationCheckStatusEnum }),
        ...(paymentInfoParam && { naimixPaymentInfo: paymentInfoParam as NaimixRegistrationCheckStatusEnum }),
        ...(citizenshipParam && { citizenshipId: citizenshipParam }),
        ...(roleParam && { role: roleParam as UserRoleEnum }),
      },
    },
  });

  const userPaginated = dataUsers?.getUsers;
  const users = useMemo(() => userPaginated?.users || [], [userPaginated?.users]);
  return { users, userPaginated, loadingUsers, error, page };
};
